export default "__VITE_ASSET__7823521e__"